module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.1cd01b1d.woff";